import * as React from 'react';

import {DynamicStatusButton} from 'shells/button/dynamic-status-button/dynamic-status-button';

import type {ThreadType} from 'nutshell-graphql-types';

import {RouteContext} from '../../../route-context';

import {getHeaderContent, getPopoverContent, getStatusButtonText} from './helpers';

type Props = {
    isEnabled: boolean;
    isConnected: boolean;
    threadType: ThreadType;
    phoneNumber?: string | null | undefined;
};

export function HeaderStatusButton(props: Props) {
    const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);

    const isEmbedded = React.useContext(RouteContext).isEmbedded;

    return (
        <DynamicStatusButton
            text={getStatusButtonText(
                props.isConnected,
                props.isEnabled,
                props.threadType,
                props.phoneNumber
            )}
            headerType={props.isEnabled ? 'success' : 'warning'}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            headerContent={getHeaderContent(props.isConnected, props.isEnabled, props.threadType)}
            popoverContent={getPopoverContent(
                props.isConnected,
                props.isEnabled,
                isEmbedded,
                props.threadType
            )}
        />
    );
}
